import React from 'react';
import Create from 'containers/rest/Create';
import Form from '../components/Form';

const CompanySizesCreate = props => (
  <Create {...props} resource="companySizes">
    <Form />
  </Create>
);

CompanySizesCreate.propTypes = {};

export default CompanySizesCreate;
